export { default as AddSkillDetailsModalController } from './AddSkillDetailsModalController';
export { AddSkillDetailsModal }                      from './AddSkillDetailsModal';



// WEBPACK FOOTER //
// ./src/components/addSkillDetailsModal/index.js